module.exports = __webpack_public_path__ + "img/hr-heated-ending-up-1.840ffdbc.png";